import { ApiSearchResultTile } from './ApiSearchResultTile'
import { ChannelSearchResultTile } from './ChannelSearchResultTile'
import { DocumentSearchResultTile } from './DocumentSearchResultTile'
import { MessageSearchResultTile } from './MessageSearchResultTile'
import { OperationSearchResultTile } from './OperationSearchResultTile'
import { SchemaSearchResultTile } from './SchemaSearchResultTile'
import { ServerSearchResultTile } from './ServerSearchResultTile'
import { SEARCH_RESULT_TYPE, SearchResult } from '~/portal/types/search'

interface SearchResultTileProps {
  result: SearchResult
  onClose: () => void
  tileKey: string
}

export const SearchResultTile = ({ result, onClose, tileKey }: SearchResultTileProps) => {
  if (result.resultType === SEARCH_RESULT_TYPE.OPERATION && result.messageId) {
    return <MessageSearchResultTile result={result} onClose={onClose} tileKey={tileKey} />
  }

  if (result.resultType === SEARCH_RESULT_TYPE.OPERATION && result.serverId) {
    return <ServerSearchResultTile result={result} onClose={onClose} tileKey={tileKey} />
  }

  if (result.resultType === SEARCH_RESULT_TYPE.OPERATION && result.channelId) {
    return <ChannelSearchResultTile result={result} onClose={onClose} tileKey={tileKey} />
  }

  if (result.resultType === SEARCH_RESULT_TYPE.SCHEMA) {
    return <SchemaSearchResultTile result={result} onClose={onClose} tileKey={tileKey} />
  }

  if (result.resultType === SEARCH_RESULT_TYPE.OPERATION) {
    return <OperationSearchResultTile result={result} onClose={onClose} tileKey={tileKey} />
  }

  if (result.resultType === SEARCH_RESULT_TYPE.API) {
    return <ApiSearchResultTile result={result} onClose={onClose} tileKey={tileKey} />
  }

  return <DocumentSearchResultTile result={result} onClose={onClose} tileKey={tileKey} />
}